import React from 'react'
import Helmet from 'react-helmet'
import DayPicker, { DateUtils } from 'react-day-picker'
import 'react-day-picker/lib/style.css'

export default class NeoCalendar extends React.Component {
  static defaultProps = {
    numberOfMonths: 1,
  }

  constructor(props) {
    super(props)
    this.handleDayClick = this.handleDayClick.bind(this)
    this.handleResetClick = this.handleResetClick.bind(this)
    this.state = this.getInitialState()
  }

  getInitialState() {
    return {
      from: undefined,
      to: undefined,
    }
  }

  handleDayClick(day) {
    const range = DateUtils.addDayToRange(day, this.state)
    this.props.setFromDate(range.from)
    this.props.setToDate(range.to)
    this.setState(range)
  }

  handleResetClick() {
    this.setState(this.getInitialState())
  }

  render() {
    const { from, to } = this.state
    const modifiers = { start: from, end: to }
    return (
      <div className='RangeExample'>
        {/* <p>
          {!from && !to && 'Please select the first day.'}
          {from && !to && 'Please select the last day.'}
          {from &&
            to &&
            `Selected from ${from.toLocaleDateString()} to
                ${to.toLocaleDateString()}`}{' '}
        </p> */}
        <DayPicker
          className='Selectable'
          numberOfMonths={this.props.numberOfMonths}
          selectedDays={[from, { from, to }]}
          modifiers={modifiers}
          onDayClick={this.handleDayClick}
          disabledDays={{
            after: new Date(),
          }}
        />
        <Helmet>
          <style>
            {`
            .DayPicker-Caption > div {
              color: #171D35;
              font-size: 18px;
              font-weight: bold;            
            }
            .DayPicker-Weekday {
              color: #171D35;
              font-size: 9px;
              font-weight: bold;
            }
            .Selectable .DayPicker-Day--selected:not(.DayPicker-Day--start):not(.DayPicker-Day--end):not(.DayPicker-Day--outside) {
              background: -webkit-linear-gradient(90deg, #F15D2A, #FCC220) !important;
              background-color: #FCC220;
              color: #FFFFFF;
            }
            .Selectable .DayPicker-Day {
              border-radius: 0 !important;
            }
            .Selectable .DayPicker-Day--start {
              border-top-left-radius: 50% !important;
              border-bottom-left-radius: 50% !important;
              background: -webkit-linear-gradient(45deg, #F15D2A, #F15D2A, #FCC220) !important;
              background-color: #FCC220;
            }
            .Selectable .DayPicker-Day--end {
              border-top-right-radius: 50% !important;
              border-bottom-right-radius: 50% !important;
              background: -webkit-linear-gradient(135deg, #F15D2A, #F15D2A, #FCC220) !important;
              background-color: #FCC220;
            }
            .DayPicker-Day--disabled {
              cursor: default;
              pointer-events: none;//this will disable mouse event
            }
          `}
          </style>
        </Helmet>
      </div>
    )
  }
}
